var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8509 6.05896C2.92164 6.0883 2.99921 6.10449 3.08057 6.10449C3.16192 6.10449 3.23949 6.0883 3.31024 6.05896C3.381 6.02968 3.4473 5.98628 3.50483 5.92876L5.90483 3.52876C6.13915 3.29444 6.13915 2.91454 5.90483 2.68023C5.67052 2.44591 5.29062 2.44591 5.0563 2.68023L3.68057 4.05596L3.68057 0.704492C3.68057 0.373121 3.41194 0.104492 3.08057 0.104492C2.7492 0.104492 2.48057 0.373121 2.48057 0.704492L2.48057 4.05596L1.10483 2.68023C0.870516 2.44591 0.490617 2.44591 0.256303 2.68023C0.0219882 2.91454 0.0219882 3.29444 0.256303 3.52876L2.6563 5.92876C2.71383 5.98628 2.78013 6.02968 2.8509 6.05896Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8dde216005ebc4bc946b678eff2c86dd.svg";
export { ForwardRef as ReactComponent };